import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BTProgrssBar = React.lazy(function () {
    return import('../../bootstrap-components/components/BTProgressBar');
});
var bootStrapProgressBar = function (props) {
    return (React.createElement(BTProgrssBar, __assign({}, props)));
};
var ProgrssBar = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapProgressBar(props);
            break;
        default:
            componentToDisplay = bootStrapProgressBar(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
ProgrssBar.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(ProgrssBar);
//# sourceMappingURL=ProgressBar.js.map